import Request from "@/shared/utils/_request";

class Post {
    constructor () {
    }

    // 支付订单
    payServiceFee(payload) {
        return Request.post("/job/pay-service-fee", payload);
    }

    // 全职和兼职职位订单创建 job/createTransaction
    createTransaction(payload) {
        return Request.post("/job/createTransaction", payload);
    }

    // 全职和兼职职位创建
    createPost(payload) {
        return Request.post("/job/createActing", payload);
    }

    /*
    重构
     */

    //职位列表接口
    getPostList(payload) {
        return Request.post("/job/get-list", payload);
    }

    getMoneyList(payload) {
        return Request.post("/money/get-list", payload);
    }

    raiseprice(payload) {
        return Request.post("/money/raise-price", payload);
    }

    addamount(payload) {
        return Request.post("/money/add-amount", payload);
    }

    getMoneytask(payload) {
        return Request.post("/money/get-task", payload);
    }

    moneypause(payload) {
        return Request.post("/money/pause", payload);
    }

    moneystar(payload) {
        return Request.post("/money/start", payload);
    }

    moneyoffline(payload) {
        return Request.post("/money/offline", payload);
    }

    moneyreview(payload) {
        return Request.post("/money/review", payload);
    }
    moneyduplicate(payload) {
        return Request.post("/money/duplicate", payload);
    }
    /*
  end
   */
    getPostInfo(payload) {
        return Request.post("/job/detail", payload);
    }

    getCompanyInfo(payload) {
        return Request.post("/company/suggest", payload);
    }

    savePost(payload) {
        return Request.post("/job/create", payload);
    }

   getJobRequirementRecommend(payload) {
    return Request.http("/aibiz/ie/getJobRequirementRecommend", payload,'java');
   }

    editPost(payload) {
        return Request.post("/job/update", payload);
    }

    publish(payload) {
        return Request.post("/job/publish", payload);
    }

    refresh(payload) {
        return Request.post("/job/refresh", payload);
    }

    offline(payload) {
        return Request.post("/job/offline", payload);
    }

    transform(payload) {
        return Request.post("/job/transform", payload);
    }

    getSuggest(payload) {
        return Request.post("/account/suggest", payload);
    }

    getNotice(payload) {
        return Request.post("/job/case-notice/get-list", payload);
    }

    examineRefuse(payload) {
        return Request.post("/job/reject", payload);
    }

    /**
     * 做单验证
     * @param {{resume_id,job_id}} payload
     *
     */
    checkPost(payload) {
        return Request.post("/post/checkEnablePost", payload);
    }

    /**
     * 添加案情通告
     * @param {{job_id,content}} payload
     */
    addAnnouncement(payload) {
        return Request.post("/job/case-notice/create", payload);
    }

    /**
     * 更新案情通告
     * @param {{id,content}} payload
     */
    updateNotice(payload) {
        return Request.post('/job/case-notice/update', payload)
    }

    getJobAttachments(payload) {
        return Request.post('/job/getPostAttachmentIds', payload)
    }

    // 修改服务费
    changeServiceFee(payload) {
        return Request.post('/job/createAuditLog', payload)
    }

    // 计算总佣金和平台服务费等
    calcCommission(payload) {
        return Request.post('/job/compute-commission', payload)
    }

    // 发布职位计算佣金服务费等
    createCalcCommission(payload) {
        return Request.post('/job/computeJobCommission', payload)
    }

    /*
    重构灵活用工接口
    */

    // 灵活用工职位详情
    partTimeOrderList(payload) {
        return Request.post('/columbus-job/request', {
            url: '/post/list',
            method: 'post',
            json: JSON.stringify(payload)
        })
    }

    // 职位录用
    confirmEmploy(params) {
        return Request.post('/columbus-job/request', {
            url: '/post/employ',
            method: 'post',
            json: JSON.stringify(params)
        })
    }
    // 灵活用工工资结算拒绝
    salaryRefuse(params) {
        return Request.post('/columbus-job/request', {
            url: '/post/settlement_reject',
            method: 'post',
            json: JSON.stringify(params)
        })
    }
    paySalary(params) {
        return Request.post('/columbus-job/request', {
            url: '/post/settlement_apply',
            method: 'post',
            json: JSON.stringify(params)
        })
    }
    // // 职位录用
    // confirmEmployTask(params) {
    //   return Request.post('/columbus-job/request', {
    //     url: '/post/employ',
    //     method: 'post',
    //     json: JSON.stringify(params)
    //   })
    // }
    //辞退
    Dismissal(params) {
        return Request.post('/columbus-job/request', {
            url: '/post/finished',
            method: 'post',
            json: JSON.stringify(params)
        })
    }

    // 到岗
    confirmEntry(params) {
        return Request.post('/columbus-job/request', {
            url: '/post/entry',
            method: 'post',
            json: JSON.stringify(params)
        })
    }

    //删除已录取职位
    parTimeDeleteJob(params) {
        return Request.post('/columbus-job/request', {
            url: '/post/reject',
            method: 'post',
            json: JSON.stringify(params)
        })
    }

    //删除已录取职位--灵工任务
    parTimeDeleteJobTask(params) {
        return Request.post('/columbus-job/request', {
            url: '/post/taskSignReject',
            method: 'post',
            json: JSON.stringify(params)
        })
    }

    //职位详情
    partTimeDetail(id) {
        return Request.post('/columbus-job/request', {
            url: '/post/' + id,
            method: 'get',
        })
    }

    /*   */

    //
    partTimeStatusCounts(payload) {
        return Request.post('/columbus-job/request', {
            url: '/post/stat',
            method: 'post',
            json: JSON.stringify(payload)
        })
    }

    //发布任务 --- 类型数据
    getCommon(payload) {
        return Request.get("/money/get-common", payload);
    }

    //发布任务 --- 城市选择
    getCity(payload) {
        return Request.get("/money/common-area", payload);
    }

    //发布任务 --- 发布或编辑赚钱任务
    postTask(payload) {
        return Request.post("/money/post-task", payload);
    }

    //发布任务 --- 获取任务详情
    getTask(payload) {
        return Request.get(`/money/get-task?id=${payload.id}`, payload);
    }

    //发布任务 --- 查询公司
    queryCompany(payload) {
        return Request.get(`/money/query-company?keywords=${payload.keywords}`, payload);
    }
    //发布任务 --- 再次发布任务
    duplicatey(payload) {
        return Request.get(`/money/duplicate?id=${payload.id}`, payload);
    }
    //发布任务 --- 解冻资金接口
    unfreeze(payload) {
        return Request.get(`/money/unfreeze?id=${payload.id}`, payload);
    }
    //赚钱任务 获取用户任务单列表
    getTaskPostList(payload) {
        return Request.get(`/money/get-post-list?status=${Number(payload.status)}&page=${payload.page}&pageSize=${payload.pageSize}&uid=${payload.uid}&taskid=${payload.taskid}`);
    }
    //赚钱任务 任务单审核接口
    postTaskReview(payload) {
        return Request.post('/money/post-review', payload);
    }
    //必看好职位 --- 列表
    getMustSeeList(payload) {
        return Request.get(`/job/getMustSeeList`, payload);
    }
    //必看好职位 --- 删除
    deleteMustSeeCategory(payload) {
        return Request.post(`/job/deleteMustSeeCategory`, payload);
    }
    //必看好职位 --- 添加
    setMustSeeCategory(payload) {
        return Request.post(`/job/setMustSeeCategory`, payload);
    }
    //必看好职位 --- 设置
    setMustSee(payload) {
        return Request.post(`/job/setMustSee`, payload);
    }
    //必看好职位 --- 取消
    cancelMustSee(payload) {
        return Request.post(`/job/cancelMustSee`, payload);
    }

    /**
     *  职位资源添加
     */
    //获取文案列表
    getContentList(params) {
        return Request.post(`/promotion/case-words/get-all`, params);
    }
    //添加文案
    addContentJob(params) {
        return Request.post(`/promotion/case-words/create`, params);
    }
    //修改文案
    editContentJob(params) {
        return Request.post(`/promotion/case-words/update`, params);
    }
    //删除文案
    deleteContentJob(params) {
        return Request.post(`/promotion/case-words/delete`, params);
    }

    //获取文章列表
    getArticleList(params) {
        return Request.post(`/promotion/article/get-all`, params);
    }
    //添加文章
    addArticleJob(params) {
        return Request.post(`/promotion/article/create`, params);
    }
    //修改文章
    editArticleJob(params) {
        return Request.post(`/promotion/article/update`, params);
    }
    //删除文章
    deleteArticleJob(params) {
        return Request.post(`/promotion/article/delete`, params);
    }

    //添加海报
    addPosterJob(params) {
        return Request.post(`/promotion/poster/create`, params);
    }
    //获取海报资源列表
    getPosterList(params) {
        return Request.post(`/promotion/poster/get-all`, params);
    }
    //删除海报
    deletePosterList(params){
        return  Request.post(`/promotion/poster/delete`, params);
    }

    //资源添加
    addResourceJob(params){
        return Request.post(`/promotion/resource/create`, params);
    }

    //获取资源列表
    getResourceList(params) {
        return Request.post(`/promotion/resource/get-all`, params);
    }
    //删除资源
    deleteResourceList(params){
        return Request.post(`/promotion/resource/delete`, params);
    }

    //视频封面添加
    addVdieoCover(params){
        return Request.post(`/promotion/resource/update`, params);
    }
    //关联直播课程
    addLiveJob(params){
        return Request.post(`/job/update-job-live`, params);
    }
    // 搜索直播
    searchLive(params){
        return Request.post(`/job/live-search`,params);
    }
    //查询直播
    getLiveJob(params){
        return Request.post(`/job/get-job-live`, params);
    }
}

export const post = new Post();
